const toDoubleDigit = (number) => {
    return number < 10 ? `0${number}` : number.toString();
};
export const getChannelProgress = (program) => {
    return (Date.now() - program.start) / (program.end - program.start);
};
export const getChannelSchedule = (program) => {
    const startDate = new Date(program.start);
    const endDate = new Date(program.end);
    const startTime = `${startDate.getHours()}:${toDoubleDigit(startDate.getMinutes())}`;
    const endTime = `${endDate.getHours()}:${toDoubleDigit(endDate.getMinutes())}`;
    return `${startTime} - ${endTime}`;
};
//# sourceMappingURL=channels.js.map